import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Imgix from 'react-imgix'
import { Table } from 'react-bootstrap'
import { ShimmerTable } from 'react-shimmer-effects'
import { useErrorService, useUserService } from '@abroad/components'
import { getAssessmentCurrentData } from '../../utils/date'
import { commonConst } from '../../constants/common'
import API from '../../utils/API'
import moment from 'moment-timezone'

const CompletedSessions = () => {
  const history = useHistory()
  const { user } = useUserService()
  const Error = useErrorService()
  const [isLoading, setIsLoading] = useState(true)
  const [sessions, setSessions] = useState([])

  useEffect(() => {
    const getCompletedSessions = async () => {
      try {
        if (!user?._id) {
          setIsLoading(false)
          return
        }
        const { data: sessionData } = await API.session.getSession()
        const sessionDataFilteredByDate = [
          ...(sessionData?.clients || []),
          ...(sessionData?.teams || []),
        ].sort((a, b) => {
          return moment(a.date) > moment(b.date) ? -1 : 1
        })
        setSessions(sessionDataFilteredByDate)
        setIsLoading(false)
      } catch (e) {
        setIsLoading(false)
        Error.showError(e)
      }
    }
    getCompletedSessions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRowClick = (sessionId) => {
    history.push(`/coaching/session/${sessionId}`)
  }

  const getImageName = (session) => {
    const { mediaModules = [], medias = [] } = session
    const r1 = mediaModules.find((e) => e.imageFilename)
    if (r1) {
      return r1.imageFilename
    }
    const r2 = medias.find((e) => e.imageFilename)
    return r2?.imageFilename || commonConst.abroadPlaceholderImage
  }

  const getTitleBySessionType = (session) => {
    if (session?.isGrowthSession) {
      return 'Growth Plan'
    }
    return !!session?.clientId ? 'Individual' : 'Group'
  }

  return (
    <div className='table-responsive mt-32px'>
      {isLoading ? (
        <ShimmerTable col={4} row={5} />
      ) : (
        <Table className='custom-table align-middle table-hover'>
          <thead>
            <tr className='s10a border-dark'>
              <th width='7%'></th>
              <th width='27%'>DATE</th>
              <th width='27%'>SESSION TYPE</th>
              <th width='27%'>COACH</th>
              <th width='12%' className='text-end'>
                NOTES
              </th>
            </tr>
          </thead>
          {sessions.length === 0 && (
            <tr>
              <td className='text-center s8 py-3' colSpan='5'>
                No sessions found.
              </td>
            </tr>
          )}
          <tbody>
            {sessions.length > 0 &&
              !isLoading &&
              sessions.map((session, index) => (
                <tr
                  key={session?._id || index}
                  className='cursor-pointer'
                  onClick={() => handleRowClick(session._id)}>
                  <td width='7%' className='ps-0'>
                    <div>
                      <Imgix
                        className='border-radius-5'
                        imgixParams={{
                          crop: 'edges',
                          fit: 'crop',
                          w: 144,
                          h: 144,
                        }}
                        src={`${
                          process.env.REACT_APP_IMG_SOURCE
                        }/${getImageName(session)}`}
                        height={48}
                        width={48}
                        alt='image'
                      />
                    </div>
                  </td>
                  <td width='27%'>
                    {getAssessmentCurrentData(session?.date, 'MMMM Do YYYY')}
                  </td>
                  <td width='27%'>{getTitleBySessionType(session)}</td>
                  <td width='27%'>{session?.coachId?.fullName}</td>
                  <td width='12%' className='text-end'>
                    <div className='pe-2 text-saffron-700 hover'>View</div>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      )}
    </div>
  )
}

export default CompletedSessions
